var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-formation-popup', {
    attrs: {
      "data-to-show": _vm.isNewFormationPopupDisplayed,
      "formationToEdit": _vm.formations[_vm.indexFormationToEdit]
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewFormationPopup(false);
      },
      "addFormation": function (newValue) {
        _vm.addNewFormation(newValue);
      },
      "modifyFormation": function (newValue) {
        _vm.modifyFormation(newValue);
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15 mx-10"
  }, [_vm._v("Formations")]), _vm._v(" "), _vm.isErrorMaxLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8"
  }, [_vm._v("\n    Vous ne pouvez pas sélectionner plus d'une formation.\n  ")]) : _vm._e(), _vm._v(" "), _vm.isErrorMinLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8"
  }, [_vm._v("\n    Afin d'avoir un rendu visuel optimal, il faut sélectionner exactement une\n    formation.\n  ")]) : _vm._e(), _vm._v(" "), _vm.formations.length === 0 ? _c('div', [_c('h6', {
    staticClass: "mx-15 text-gray-600"
  }, [_vm._v("\n      Aucune formation n'a été renseignée sur votre Neopass.\n    ")]), _vm._v(" "), _c('h6', {
    staticClass: "mx-15 text-gray-600 mt-5"
  }, [_vm._v("\n      Pour mettre en avant vos formations, cliquer sur le bouton \"ajouter une\n      nouvelle formation\"\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Ajouter une nouvelle formation",
      "uppercase": true,
      "icon": "plus-circle",
      "type-shadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        _vm.isNewFormationPopupDisplayed = true;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.formations.length > 0 ? _c('div', [_c('add-button', {
    staticClass: "mb-8 mx-5 md:mx-10",
    attrs: {
      "libelle": "Ajouter une nouvelle formation"
    },
    on: {
      "add": function ($event) {
        _vm.isNewFormationPopupDisplayed = true;
      }
    }
  }), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "handle": ".handle"
    },
    on: {
      "end": function ($event) {
        _vm.drag = false;
      },
      "start": function ($event) {
        _vm.drag = true;
      }
    },
    model: {
      value: _vm.form.data.formations,
      callback: function ($$v) {
        _vm.$set(_vm.form.data, "formations", $$v);
      },
      expression: "form.data.formations"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l([].concat(_vm.formations, _vm.newFormations), function (formation, i) {
    return _c('div', {
      key: 'formation' + i,
      staticClass: "grid grid-cols-10 md:gap-x-4 py-5 odd:bg-gray-200 items-center",
      class: formation.value.new ? ' odd:bg-opacity-25' : ' odd:bg-opacity-50'
    }, [_c('div', {
      staticClass: "col-span-1 md:col-span-2 justify-self-end md:justify-self-center handle",
      class: formation.value.new ? ' opacity-25' : ''
    }, [_c('icon', {
      staticClass: "text-indigo-600 w-5 h-5 cursor-move",
      attrs: {
        "name": "move"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 grid grid-cols-12"
    }, [_c('div', {
      staticClass: "col-span-2 h-full flex items-center"
    }, [_vm.changedFormations[formation.value.type + (formation.value.value.intitule_parcours ? formation.value.value.intitule_parcours : '')] || formation.value.new ? _c('CVNewValue', {
      attrs: {
        "old": _vm.newer.data.parcours[formation.value.type + (formation.value.value.intitule_parcours ? formation.value.value.intitule_parcours : '')],
        "right": false,
        "is-new": formation.value.new
      },
      on: {
        "change": function (newValue) {
          formation.value = _vm.replaceValues(formation.value, newValue);
          _vm.newer.data.parcours[formation.value.type + (formation.value.value.intitule_parcours ? formation.value.value.intitule_parcours : '')] = false;
        },
        "addNew": function (newValue) {
          _vm.importFromNeopass(newValue);
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-10",
      class: formation.value.new ? ' opacity-25' : ''
    }, [_c('p', {
      staticClass: "text-base font-normal"
    }, [_vm._v("\n                " + _vm._s(formation.value.value.intitule_parcours ? formation.value.value.intitule_parcours : '') + "\n                " + _vm._s(formation.value.value.duree_formation ? '(' + formation.value.value.duree_formation + ' h)' : '') + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "text-base font-light"
    }, [_vm._v("\n                " + _vm._s(formation.value.type) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "text-sm italic font-light"
    }, [_vm._v("\n                " + _vm._s(formation.value.value.debut_parcours ? new Date(formation.value.value.debut_parcours).toLocaleDateString() : '') + "\n                " + _vm._s(formation.value.value.fin_parcours ? (formation.value.value.debut_parcours ? ' - ' : '') + new Date(formation.value.value.fin_parcours).toLocaleDateString() : '') + "\n                " + _vm._s(formation.value.value.localisation_parcours ? (formation.value.value.debut_parcours || formation.value.value.fin_parcours ? ' - ' : '') + formation.value.value.localisation_parcours : '') + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2 flex space-x-3"
    }, [_c('radio-button', {
      attrs: {
        "name": 'formation_' + i + '_display',
        "value": ((((_vm.form || {}).data || {}).formations || [])[i] || {}).isDisplayed || false
      },
      on: {
        "input": function (newValue) {
          _vm.displayFormation(i);
        },
        "loseFocus": function ($event) {
          return _vm.saveDatas();
        }
      }
    }), _vm._v(" "), !formation.fromNeopass ? _c('div', {
      staticClass: "cursor-pointer px-2 relative",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayMenuMore(i);
        }
      }
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    }), _vm._v(" "), _vm.menuMoreDisplayed === i ? _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.hideMenuMore,
        expression: "hideMenuMore"
      }],
      staticClass: "absolute text-gray-600 bg-white px-5 py-4 rounded-xl shadow-lg flex flex-col space-y-2 text-sm -right-full z-10"
    }, [_c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayModifyFormationPopup(i);
        }
      }
    }, [_vm._v("\n                  Modifier\n                ")]), _vm._v(" "), _c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeFormation(i);
        }
      }
    }, [_vm._v("\n                  Supprimer\n                ")])]) : _vm._e()], 1) : _vm._e()], 1)]);
  }), 0)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }